import { Navigate } from "react-router-dom";
import { useAuth } from "./auth/useAuth";
import { Outlet } from "react-router-dom";

export function PrivateRoute({ component: Component, allowedRoles, ...rest }) {
  const auth = useAuth();

  return (auth?.getRoles()?.find(role => allowedRoles?.includes(role)) ? <Outlet /> : <Navigate to="/" />);
}